import { useContext } from "react";
import { VideosContext } from "../providers/VideosProvider/videosProvider";

export const useVideoContext = () => {
  return useContext(VideosContext);
};
